var MAX_THUMBNAIL_TEMPLATE_TO_LOAD = 100;

export { MAX_THUMBNAIL_TEMPLATE_TO_LOAD };
//# sourceMappingURL=constants.js.map
